// extracted by mini-css-extract-plugin
module.exports = {"contents":"Dk-z","sectionHeading":"Ek-z"};